export default __webpack_public_path__ + "static/media/actualpasswordimg.9d2bbf51.png";